import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyC2xjbAePukISF0lJE1S-oqZ_6yf5tx86o",
  authDomain: "pulsechatapp-dfe55.firebaseapp.com",
  databaseURL: "https://pulsechatapp-dfe55.firebaseio.com",
  projectId: "pulsechatapp-dfe55",
  storageBucket: "pulsechatapp-dfe55.appspot.com",
  messagingSenderId: "1018571406200",
  appId: "1:1018571406200:web:46ad9950110ede2ee6e68d",
  measurementId: "G-L2GWPS0B7Z"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
